module.exports = __webpack_public_path__ + "assets/link.ab52c20b.svg";